import { AdapterCache } from '../../requestCaches/adaptersCache';
import { Map as ImmutableMap } from 'immutable';
import CrmObjectTypeRecord from 'customer-data-filters-ui/fetcher/CrmObjectTypeRecord';
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
export const objectDefinitionsAdapterEndpointAll = 'inbounddb-meta/v1/object-types/for-portal';
export const enabledAndDisabledObjectDefinitionsAdapterEndpointAll = 'customer-object-types/v1/for-portal/include-disabled';
export const objectDefinitionsAdapterEndpointBatched = 'inbounddb-meta/v1/object-types/batch-get';
export default class ObjectDefinitionsAdapterConfig {
  constructor() {
    this.allObjectDefinitionsCache = new AdapterCache();
    this.batchedObjectDefinitionsCache = new AdapterCache();
  }
  getFetcher() {
    return http.get;
  }
  fetchDataWithEndpointAll(httpClient) {
    const cachedObjectDefinitions = this.allObjectDefinitionsCache.get('OBJECT_DEFINITIONS');
    if (cachedObjectDefinitions) {
      return cachedObjectDefinitions;
    }
    const options = {
      query: {
        portalId: PortalIdParser.get()
      }
    };
    const request = httpClient(enabledAndDisabledObjectDefinitionsAdapterEndpointAll, options).then(response => {
      const {
        enabledObjectTypeDefinitions,
        disabledObjectTypeDefinitions
      } = response;
      const objectDefinitions = [];
      enabledObjectTypeDefinitions.forEach(objectDefinition => {
        objectDefinitions.push(Object.assign({}, objectDefinition, {
          disabled: false
        }));
      });
      disabledObjectTypeDefinitions.forEach(objectDefinition => {
        objectDefinitions.push(Object.assign({}, objectDefinition, {
          disabled: true
        }));
      });
      return objectDefinitions;
    });
    this.allObjectDefinitionsCache.set('OBJECT_DEFINITIONS', request);
    return request;
  }
  getBatchedObjectDefinitionsFromCache(objectIds) {
    const cachedObjectDefinitions = objectIds.map(objectId => this.batchedObjectDefinitionsCache.get(objectId));
    const objectIdsWithMissingObjectDefinition = objectIds.filter((__objectId, index) => !cachedObjectDefinitions[index]);
    if (objectIdsWithMissingObjectDefinition.length > 0) {
      Raven.captureException(new Error(`ObjectDefinitionsAdapter could not fetch all objectIds for assetFamily: ${objectIdsWithMissingObjectDefinition.join(', ')}`));
    }
    return cachedObjectDefinitions.filter(objectDefinition => !!objectDefinition);
  }
  fetchDataWithEndpointBatched(httpClient, objectIds) {
    const objectIdsToFetch = objectIds.filter(objectId => !this.batchedObjectDefinitionsCache.get(objectId));
    const options = {
      query: {
        portalId: PortalIdParser.get(),
        objectType: objectIdsToFetch
      }
    };
    if (objectIdsToFetch.length === 0) {
      return Promise.resolve(this.getBatchedObjectDefinitionsFromCache(objectIds));
    }
    return httpClient(objectDefinitionsAdapterEndpointBatched, options).then(objectDefinitions => {
      objectDefinitions.forEach((objectDefinition, index) => {
        const objectId = objectIdsToFetch[index];
        this.batchedObjectDefinitionsCache.set(objectId, objectDefinition);
      });
      return this.getBatchedObjectDefinitionsFromCache(objectIds);
    });
  }
  fetchData(httpClient, __assetFamily, variables) {
    const {
      ids: objectIds
    } = variables;
    const hasObjectIds = Array.isArray(objectIds) && objectIds.length > 0;
    if (hasObjectIds) {
      return this.fetchDataWithEndpointBatched(httpClient, objectIds);
    }
    return this.fetchDataWithEndpointAll(httpClient);
  }
  formatData(objectDefinitions) {
    return objectDefinitions.reduce((acc, objectDefinition) => {
      const {
        name,
        objectTypeId,
        pluralForm,
        singularForm,
        primaryDisplayLabelPropertyName,
        disabled
      } = objectDefinition;
      if (!this.includeObject(objectDefinition)) {
        return acc;
      }
      const customObjectInfo = CrmObjectTypeRecord({
        name,
        objectTypeId,
        pluralForm,
        singularForm,
        primaryDisplayLabelPropertyName,
        disabled
      });
      return acc.set(objectTypeId, customObjectInfo);
    }, ImmutableMap());
  }
  clearCache() {
    this.allObjectDefinitionsCache.clearAll();
    this.batchedObjectDefinitionsCache.clearAll();
  }
}